<template>
  <v-container class="pa-5">
    <v-card class="">
      <v-toolbar flat elevation="4">
        <v-card class="icon">
          <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large=""
            >mdi-chart-histogram</v-icon
          >
        </v-card>
        <div class="usuario"><h3>LISTADO DE REPORTES</h3></div>
      </v-toolbar>
      <v-row>
        <v-col cols="12">
          <v-container fluid class="mt-5">
            <v-row>
              <v-col cols="12" sm="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dates"
                      label="Selecciona el rango de fechas para consultar tickets "
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="#1D3C7F"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="es-es"
                    range
                    v-model="dates"
                    no-title
                    scrollable
                    color="#294697"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="#294697" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="#294697"
                      @click="consultarIncidentes(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  :loading="loading"
                  color="#294697"
                  tile
                  dark
                  class="mt-1"
                  @click="buscarIncidentes()"
                >
                  <v-icon> mdi-magnify </v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-container>
        <!-- Grafica de cantidad de casos por dia -->
        <div class="containt-charts">
          <v-card width="100%" max-height="">
            <v-card-title class="d-flex justify-center card-chart">
              <v-card tile width="95%" class="card--color1">
                <v-card-text class="card-chart--text">
                  <canvas id="CasosDiasMes"></canvas>
                </v-card-text>
              </v-card>
            </v-card-title>
            <v-card-subtitle class="title-card">
              {{ dataDias.titulo }}
            </v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text class="subtitle-card">
              {{ dataDias.sub }}
            </v-card-text>
          </v-card>
        </div>
        <!-- Grafica de cantidad de cada requerimiento -->
        <v-row>
          <v-col cols="12" sm="8">
            <div class="containt-charts">
              <v-card width="750" max-height="">
                <v-card-title class="d-flex justify-center card-chart">
                  <v-card tile width="680" class="card--color2">
                    <v-card-text class="card-chart--text">
                      <canvas id="CasosPorRequerimientos" height="500"></canvas>
                    </v-card-text>
                  </v-card>
                </v-card-title>
                <v-card-subtitle class="title-card">
                  {{ dataRequerimientos.titulo }}
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="subtitle-card">
                  {{ dataRequerimientos.sub }}
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <!-- Grafica 3 -->
            <div class="containt-charts">
              <v-card width="750" max-height="">
                <v-card-title class="d-flex justify-center card-chart">
                  <v-card width="680" class="p-0 card--color3">
                    <v-card-text class="card-chart--text">
                      <canvas height="350" id="estadoDeCasos"></canvas>
                    </v-card-text>
                  </v-card>
                </v-card-title>
                <v-card-subtitle class="title-card">
                  REPORTE DE ESTADO DE CASOS
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="subtitle-card">
                  Reporte que muestra la cantidad de casos atentidos por el
                  robot 
                  <span class="font-weight-bold">({{ cerradoRobot }})</span
                  >, por el usuario
                  <span class="font-weight-bold">({{ cerradosUser }})</span> y los
                  casos pendientes
                  <span class="font-weight-bold"
                    >({{ pendientesPorCerrar }}) 
                  </span>
                  <br>
                  Total de casos:
                  <span class="font-weight-bold" style="color: #F34A3B"
                    >{{ total }} </span
                  >
                  
                </v-card-text>
              </v-card>
            </div>
            <!-- Grafica 4 -->
            <div class="containt-charts">
              <v-card width="750" max-height="">
                <v-card-title class="d-flex justify-center card-chart">
                  <v-card width="680" class="p-0 card--color4">
                    <v-card-text class="card-chart--text">
                      <canvas height="350" id="porcentajeCumplimiento"></canvas>
                    </v-card-text>
                  </v-card>
                </v-card-title>
                <v-card-subtitle class="title-card">
                  REPORTE DE CUMPLIMIENTO
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="subtitle-card">
                  Reporte que muestra el porcentaje de cumplimiento de casos
                  atendidos en el area el cual es del
                  <span class="font-weight-bold" style="color: #3feb4e">{{ porcentajeCumplimiento }} %</span>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
        <!-- grafica casos de cada especialista por dia -->
      <v-dialog v-model="dialog" persistent max-width="290">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          class="fecha"
          v-model="dateRangeDisplay"
          label="Selecciona el rango de fechas"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>

      <!-- Calendario con rango de fechas -->
      <v-card>
        <v-card-title>Selecciona un rango de fechas</v-card-title>
        <v-date-picker
          v-model="dateRange"
          locale="es-es"
          :range="true"
        ></v-date-picker>
        <v-card-actions>
          <v-btn text color="blue" @click="dialog = false">Cancelar</v-btn>
          <v-btn text color="blue" @click="aceptarFechas">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


      <template>
        <v-card width="100%" max-height="">
          <v-card-title class="d-flex justify-center card-chart-title">
            <v-card tile width="96%" class="card-chart-container">
              <v-card-text class="card-chart-text">
                <!-- Cambiar el ID aquí -->
                <canvas id="graficoEspecialistas" ref="graficoRef" class="grafico-canvas"></canvas>
              </v-card-text>
            </v-card>
          </v-card-title>
          <v-card-subtitle class="title-card">
            Casos asignados por especialista
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text class="subtitle-card">
            Número de casos asignados a cada especialista en el sistema.
          </v-card-text>
        </v-card>

        <!-- Spinner con el icono mdi-reload y el texto "Cargando..." debajo -->
        <v-overlay
          v-if="loading"
          :value="loading"
          opacity="0.5"
          class="loading-overlay"
        >
          <div class="loading-container">
            <v-icon class="mdi-reload loading-icon" />
            <span class="loading-text">Cargando...</span>
          </div>
        </v-overlay>
      </template>
      </v-container> 
    </v-card>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      color="#294697"
      style="color: white"
    >
      {{ text }}
      <v-btn color="#294697" depressed @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import env from "@/components/env";
import axios from "axios";
import Chart from "chart.js";
Chart.defaults.global.defaultFontColor = "#000";
Chart.defaults.global.defaultFontSize = 11;

export default {
  name: "Inicio",
  data() {
    return {
      idCargo: localStorage.getItem("idCargo"),
      dataDias: {
        titulo: "",
        sub: "",
      },
      dates: ["", ""],
      fecha: [""],
      casosEspecialistas: [], 
      menu: false,
      fechaInicio: "",
      fechaActual: "",
      dialog: false,
      loading: false,
      cerradosUser: 0,
      cerradoRobot: 0,
      pendientesPorCerrar: 0,
      total: 0,
      porcentajeCumplimiento: 0,
      dataRequerimientos: {
        titulo: "",
        sub: "",
        altoGrafica: "250",
      },
      values: [],
      snackbar: false,
      text: "",
      timeout: 5000,
      y: "top",
      x: null,
      mode: "",
      selectedDate: "",
      chart: null,
      dateRange: ["", ""], // Almacenar las dos fechas seleccionadas
      dateRangeDisplay: '',
      selectedDate: null,
      dialog: false,
      loading: false,
      casosPorEspecialista: [],
    };
  },
  
  created() {
    this.obtenerFechas();
  },
  mounted() {
    this.getChartsForMonth();

  },
  methods: {
    // Método para renderizar el gráfico
    renderChart() {
      const ctx = this.$refs.graficoRef.getContext("2d");  // Obtener el contexto del canvas
      const labels = this.casosEspecialistas.map(item => item.especialista);  // Etiquetas (especialistas)
      const data = this.casosEspecialistas.map(item => item.total_casos);  // Datos (total de casos)

      // Configuración del gráfico
      new Chart(ctx, {
        type: "bar",  // Tipo de gráfico (puede ser "bar", "line", etc.)
        data: {
          labels: labels,  // Etiquetas (especialistas)
          datasets: [{
            label: "Casos asignados",  // Título de la barra
            data: data,  // Datos a mostrar
            backgroundColor: "rgba(75, 192, 192, 0.2)",  // Color de fondo de las barras
            borderColor: "rgba(75, 192, 192, 1)",  // Color de los bordes de las barras
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "top"  // Ubicación de la leyenda
            }
          }
        }
      });
    },

    notificar(tipo, mensaje) {
      this.snackbar = true;
      this.text = mensaje;
      // console.log(`[${tipo.toUpperCase()}] ${mensaje}`);
    },

    graficarCasosPorEspecialista() {
      const ctx = document
        .getElementById("graficoEspecialistas")
        .getContext("2d");
      const labels = this.casosPorEspecialista.map((item) => item.especialista);
      const data = this.casosPorEspecialista.map((item) => item.total_casos);

      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              label: "Casos resueltos",
              data: data,
              backgroundColor: "rgba(54, 162, 235, 0.5)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    },

  // Actualiza la visualización del rango de fechas
  actualizarFechaDisplay() {
      if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
        this.dateRangeDisplay = `${this.dateRange[0]} - ${this.dateRange[1]}`;
      } else {
        this.dateRangeDisplay = "";
      }
    },

    // Acepta las fechas seleccionadas y actualiza la gráfica
    aceptarFechas() {
      this.dialog = false;
      this.actualizarFechaDisplay();
      this.consultarIncidentesPorRango();
    },

    // Consultar casos por rango de fechas
       consultarIncidentesPorRango() {
      let [fechaInicio, fechaFin] = this.dateRange || [];

      if (fechaInicio && fechaFin) {
        // Ordenar fechas si es necesario
        if (Date.parse(fechaInicio) > Date.parse(fechaFin)) {
          [fechaInicio, fechaFin] = [fechaFin, fechaInicio];
        }
      } else {
        // Fechas predeterminadas
        fechaInicio = "1900-01-01";
        fechaFin = new Date().toISOString().split("T")[0];
      }

      this.loading = true;

      axios.get(`${env.endpoint}callcenter/casosPorEspecialista`, {
          params: { fechaInicio, fechaFin },
        })
        .then((response) => {
          this.casosPorEspecialista = response.data;

          if (this.casosPorEspecialista.length === 0) {
            this.notificar(
              "warning",
              "No se encontraron datos para el rango de fechas seleccionado."
            );
          } else {
            this.graficarCasosPorEspecialista();
          }
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
          this.notificar(
            "error",
            "Ocurrió un error al obtener los datos. Intenta nuevamente."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  
    consultarCasos(fecha) {
      this.$refs.dialog.save(fecha);
    },

    getChartsForMonth() {
      let dataDias = new Array();
      let keyDataDias = new Array();

      let dataRequerimientos = new Array();
      let keyDataRequerimientos = new Array();

      axios
        .get(
          `${env.endpoint}callcenter/reporte_casos_dia?idCargo=${this.idCargo}&fechaInicio=${this.dates[0]}&fechaFin=${this.dates[1]}`
        )
        .then((res) => {
          /**
           * Grafica 1
           */
          for (var key in res.data.dias.data) {
            keyDataDias.push(key.substring(5, 11));
            dataDias.push(res.data.dias.data[key]);
          }
          this.dataDias.sub = res.data.dias.sub;
          this.dataDias.titulo = res.data.dias.titulo;

          const ctx = document.getElementById("CasosDiasMes");

          const graph = new Chart(ctx, {
            type: "line",
            data: {
              labels: keyDataDias,
              datasets: [
                {
                  label: "Casos por dias",
                  type: "bar",
                  data: dataDias,
                  backgroundColor: "rgba(71, 183,132,.5)",
                  borderColor: "#47b784",
                  borderWidth: 1,
                },
              ],
            },
            options: {
              responsive: true,
              lineTension: 1,
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      padding: 25,
                    },
                  },
                ],
              },
            },
          });
          /**
           * Grafica 2
           */
          for (var key in res.data.requerimientos.data) {
            keyDataRequerimientos.push(key);
            dataRequerimientos.push(res.data.requerimientos.data[key]);
          }
          this.dataRequerimientos.sub = res.data.requerimientos.sub;
          this.dataRequerimientos.titulo = res.data.requerimientos.titulo;
          const ctx2 = document.getElementById("CasosPorRequerimientos");
          const graph2 = new Chart(ctx2, {
            type: "horizontalBar",
            data: {
              labels: keyDataRequerimientos,
              datasets: [
                {
                  axis: "y",
                  label: "Casos por requerimiento",
                  fill: false,
                  data: dataRequerimientos,
                  backgroundColor: "#485a9aa1",
                  borderColor: "#485a9a",
                  borderWidth: 1,
                },
              ],
            },
            options: {
              indexAxis: "y",
              lineTension: 1,
              scales: {
                yAxes: [
                   {
                    ticks: {
                      beginAtZero: false,
                      padding: 10,
                    },
                  },
                ],
              },
            },
          });

          /**
           * Grafica 3
           */
          let dataEstadoDeCasos = new Array();
          dataEstadoDeCasos.push(res.data.cierre_user);
          dataEstadoDeCasos.push(res.data.robot);
          dataEstadoDeCasos.push(res.data.total - res.data.cerrados);
          this.total = res.data.total;
          this.cerradosUser = res.data.cierre_user;
          this.cerradoRobot = res.data.robot;
          this.pendientesPorCerrar = res.data.total - res.data.cerrados;
          const ctx3 = document.getElementById("estadoDeCasos");
          const graph3 = new Chart(ctx3, {
            type: "doughnut",
            data: {
              labels: [
                "Cerrados por los usuarios",
                "Cerrados por el robot",
                "Pendientes por cerrar",
              ],
              datasets: [
                {
                  fill: false,
                  data: dataEstadoDeCasos,
                  backgroundColor: [
                    "rgba(235,63,63,0.5)",
                    "rgba(255,68,6,0.5)",
                    "rgba(6,33,255,0.5)",
                  ],
                  borderColor: ["#EB3F3F", "#FF4406", "#0621FF"],
                  borderWidth: 1,
                },
              ],
            },
            options: {
              animation: {
                animateRotate: true,
              },
              responsive: true,
            },
          });
          /**
           * Grafica 4
           */
          let dataPorcentajeCumplimiento = new Array();

          let labelsPorcentajeCumplimiento = new Array();
          if (res.data.total === 0) {
            dataPorcentajeCumplimiento.push(res.data.cumplimiento);
            dataPorcentajeCumplimiento.push(0);
            labelsPorcentajeCumplimiento.push(`Sin informacion`);
            labelsPorcentajeCumplimiento.push(`Sin informacion`);
          } else {
            dataPorcentajeCumplimiento.push(res.data.cumplimiento);
            dataPorcentajeCumplimiento.push(100 - res.data.cumplimiento);
            labelsPorcentajeCumplimiento.push(
              `${dataPorcentajeCumplimiento[0]} % De Cumplimiento`
            );
            labelsPorcentajeCumplimiento.push(
              `${dataPorcentajeCumplimiento[1]} % Sin Cumplir`
            );
            this.porcentajeCumplimiento = res.data.cumplimiento;
          }
          const ctx4 = document.getElementById("porcentajeCumplimiento"); 
          const graph4 = new Chart(ctx4, {
            type: "pie",
            data: {
              labels: labelsPorcentajeCumplimiento,
              datasets: [
                {
                  fill: false,
                  data: dataPorcentajeCumplimiento,
                  backgroundColor: [
                    "rgba(63,235,164,0.5)",
                    "rgba(63,220,235,0.5)",
                  ],
                  borderColor: ["#3FEBA4", "#3FDCEB"],
                  borderWidth: 1,
                },
              ],
            },
            options: {
              animation: {
                animateRotate: true,
              },
              responsive: true,
            },
          });
        });
    },

    obtenerFechas() {
      const date = new Date();
      this.fechaInicio = new Date(date.getFullYear(), date.getMonth(), 1);
      this.fechaInicio = this.fechaInicio.toISOString().substr(0, 10);
      this.fechaActual = new Date().toISOString().substr(0, 10);
      this.dates = [this.fechaInicio, this.fechaActual];
    },

     consultarIncidentes(dates) {
      this.$refs.menu.save(dates);
    },

    buscarIncidentes() {
      if (this.dates.length == 2) {
        this.loading = true;
        if (this.dates[0] > this.dates[1]) {
          let temp = this.dates[0];
          this.dates[0] = this.dates[1];
          this.dates[1] = temp;
        }
        setTimeout(() => {
          this.getChartsForMonth();
          this.loading = false;
        }, 2000);
      } else {
        this.text =
          "Seleccione por favor dos fechas, de lo contrario no podra filtrar los resultados";
        this.snackbar = true;
      }
    },


  },
};
</script>

<style scoped>
Overlay para oscurecer el fondo mientras se carga
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 202;
}

/* Contenedor del ícono y el texto */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Estilo para el ícono mdi-reload */
.loading-icon {
  font-size: 70px;  /* Tamaño del ícono */
  color: #e2e4ec;  /* Color del ícono */
  animation: rotate 2s infinite linear;  /* Animación de rotación */
}

/* Animación de rotación para el ícono */
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Estilo para el texto de "Cargando..." */
.loading-text {
  margin-top: 10px;  /* Espacio entre el ícono y el texto */
  font-size: 18px;
  color: #daddec;  /* Color del texto */
  font-weight: bold;
}
.fecha{
  margin: 28px 740px 0px 0px;
}
/* Estilo para la tarjeta principal que contiene el gráfico */
.card-chart-container {
  background-color: #f0f0f0; /* Fondo de la tarjeta */
  padding: 16px;  /* Padding interno */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  /* Sombra para resaltar */
  height: 350px;  /* Definir altura para que el gráfico tenga suficiente espacio */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 18px 0 23px 0;
}
/* Estilo para el título de la tarjeta (donde está el gráfico) */
.card-chart-title {
  display: flex;
  justify-content: center;
  padding: 0;
  
}
/* Estilo para el canvas (gráfico) */
.grafico-canvas {
  width: 100%;  /* El gráfico ocupará todo el ancho disponible */
  height: 300px;  /* Ajusta el tamaño de la gráfica */
}
/* Estilo para el texto dentro del gráfico (canvas) */
.card-chart-text {
  padding: 0;  /* Remover padding para asegurarse de que el canvas ocupe todo el espacio */
}
/* Estilo para el subtítulo de la tarjeta */
.title-card {
  font-size: 18px;  /* Tamaño de la fuente */
  color: #333;  /* Color del texto */
  font-weight: bold;
  text-align: center;
  padding: 8px 0;  /* Espaciado superior e inferior */
}
/* Estilo para el texto descriptivo debajo del gráfico */
.subtitle-card {
  font-size: 14px;
  color: #555;  /* Color de texto más suave */
  text-align: center;
  padding: 8px 0;
}
/* Estilo para la línea divisoria */
.v-divider {
  margin: 8px 0;  /* Espaciado superior e inferior de la línea divisoria */
}
/* ---------------------------- */
.card-chart {
  position: relative;
  top: -35px;
}
.card-chart--text {
  padding: 35px;
}
.containt-charts {
  margin-top: 50px;
}
.title-card {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
}
.subtitle-card {
  font-size: 15px;
  text-transform: lowercase;
}

.card--color1 {
  background-color: rgba(163, 228, 150, 0.2);
}
.card--color2 {
  background-color: rgba(65, 121, 228, 0.2);
}
.card--color3 {
  background-color: rgba(235, 60, 60, 0.2);
}
.card--color4 {
  background-color: rgba(134, 235, 63, 0.2);
}
</style>